import { useCallback } from 'react';

import { useLockOperation, useUnlockOperation } from 'api/requests';
import { OperationEntity } from 'api/types/entity/operation';
import { useServerErrorNotify } from 'hooks';

export const useLockAndUnlockOperation = (
  operation: OperationEntity | null
) => {
  const { lock, error: lockError } = useLockOperation();
  const { unlock } = useUnlockOperation();

  const lockOperationIfPossible = useCallback(async () => {
    if (!operation?.id || operation?.versionNumber === undefined) {
      return false;
    }

    try {
      return await lock(operation?.id, operation?.versionNumber);
    } catch (error) {
      return false;
    }
  }, [lock, operation?.id, operation?.versionNumber]);

  const unlockOperation = useCallback(
    async () => unlock(operation?.id!),
    [operation?.id, unlock]
  );

  useServerErrorNotify(lockError);

  return { lockOperationIfPossible, unlockOperation };
};
